<div
    class="tw-flex tw-flex-col tw-h-[90vh] tw-max-h-[800px] tw-bg-gradient-to-br tw-from-slate-50 tw-via-white tw-to-indigo-50/30 dark:tw-from-slate-950 dark:tw-via-slate-900 dark:tw-to-indigo-950/30">
    <!-- Header -->
    <div
        class="tw-sticky tw-top-0 tw-z-50 tw-bg-white/95 dark:tw-bg-slate-900/95 tw-backdrop-blur-xl tw-border-b tw-border-slate-200/60 dark:tw-border-slate-700/60">
        <div class="tw-flex tw-items-center tw-justify-between tw-p-6 tw-pb-3 tw-pt-4">
            <div class="tw-flex tw-items-center tw-gap-4">
                <div
                    class="tw-w-12 tw-h-12 tw-bg-gradient-to-br tw-from-indigo-500 tw-to-purple-600 tw-rounded-2xl tw-flex tw-items-center tw-justify-center tw-shadow-lg tw-shadow-indigo-500/25">
                    <ng-icon name="heroUserPlus" size="24" class="tw-text-white"></ng-icon>
                </div>
                <div>
                    <h2
                        class="tw-text-2xl tw-font-bold tw-text-slate-900 dark:tw-text-slate-100 tw-tracking-tight tw-mb-0">
                        Connect with Professionals
                    </h2>
                    <p class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-400 tw-mt-1 tw-mb-0">
                        Send connection requests to network with Safety Knights members
                    </p>
                </div>
            </div>

            <button (click)="closeModal()"
                class="tw-bg-slate-100/80 tw-flex tw-p-2 tw-rounded-full dark:tw-bg-slate-800/80 tw-text-slate-600 dark:tw-text-slate-400 hover:tw-bg-slate-200/80 dark:hover:tw-bg-slate-700/80 hover:tw-text-slate-900 dark:hover:tw-text-slate-200 tw-transition-all tw-duration-200 hover:tw-scale-105">
                <ng-icon name="heroXMark" size="18"></ng-icon>
            </button>
        </div>

        <!-- Search Bar -->
        <div class="tw-px-6 tw-pb-3">
            <div class="tw-relative">
                <div
                    class="tw-flex tw-absolute tw-left-4 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-slate-400 dark:tw-text-slate-500">
                    <ng-icon name="heroMagnifyingGlass" size="20"></ng-icon>
                </div>
                <input type="text" [ngModel]="searchQuery()" (ngModelChange)="onSearchChange($event)"
                    placeholder="Search for Safety Knights members by name or email"
                    class="tw-w-full tw-pl-12 tw-pr-4 tw-py-4 tw-bg-slate-50/80 dark:tw-bg-slate-800/60 tw-border tw-border-slate-200/60 dark:tw-border-slate-700/60 tw-rounded-2xl focus:tw-outline-none focus:tw-ring-4 focus:tw-ring-indigo-500/10 dark:focus:tw-ring-indigo-400/10 focus:tw-border-indigo-400 dark:focus:tw-border-indigo-500 tw-text-slate-900 dark:tw-text-slate-100 tw-placeholder-slate-500 dark:tw-placeholder-slate-400 tw-font-medium tw-transition-all tw-duration-300" />

                @if (isLoading()) {
                <div class="tw-absolute tw-right-4 tw-top-1/2 tw-transform tw--translate-y-1/2">
                    <div class="tw-animate-spin tw-rounded-full tw-h-5 tw-w-5 tw-border-b-2 tw-border-indigo-500"></div>
                </div>
                }
            </div>
        </div>
    </div>

    <!-- Users List -->
    <div class="tw-flex-1 tw-overflow-y-auto tw-px-6 tw-py-4">
        <div class="tw-space-y-3 tw-pb-6">

            @if (isLoading()) {
            <!-- Loading skeleton -->
            <div class="tw-space-y-3">
                @for (item of [1,2,3,4,5,6]; track item) {
                <div
                    class="tw-animate-pulse tw-p-4 tw-bg-white/80 dark:tw-bg-slate-800/60 tw-border tw-border-slate-200/60 dark:tw-border-slate-700/60 tw-rounded-2xl">
                    <div class="tw-flex tw-items-start tw-gap-4">
                        <div class="tw-w-14 tw-h-14 tw-bg-slate-200 dark:tw-bg-slate-700 tw-rounded-full"></div>
                        <div class="tw-flex-1 tw-space-y-2">
                            <div class="tw-h-4 tw-bg-slate-200 dark:tw-bg-slate-700 tw-rounded tw-w-1/3"></div>
                            <div class="tw-h-3 tw-bg-slate-200 dark:tw-bg-slate-700 tw-rounded tw-w-1/2"></div>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else if (users().length === 0 && searchQuery()) {
            <!-- No results -->
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20 tw-text-center">
                <div
                    class="tw-w-20 tw-h-20 tw-bg-slate-100/80 dark:tw-bg-slate-800/80 tw-rounded-3xl tw-flex tw-items-center tw-justify-center tw-mb-6">
                    <ng-icon name="heroUser" size="32" class="tw-text-slate-400 dark:tw-text-slate-500"></ng-icon>
                </div>
                <h3 class="tw-text-lg tw-font-bold tw-text-slate-900 dark:tw-text-slate-100 tw-mb-2">No users found</h3>
                <p class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400 tw-max-w-sm tw-mb-0">
                    No Safety Knights members match your search criteria. Try different keywords.
                </p>
            </div>
            } @else if (users().length === 0 && !searchQuery()) {
            <!-- Initial state -->
            <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-20 tw-text-center">
                <div
                    class="tw-w-20 tw-h-20 tw-bg-slate-100/80 dark:tw-bg-slate-800/80 tw-rounded-3xl tw-flex tw-items-center tw-justify-center tw-mb-6">
                    <ng-icon name="heroMagnifyingGlass" size="32"
                        class="tw-text-slate-400 dark:tw-text-slate-500"></ng-icon>
                </div>
                <h3 class="tw-text-lg tw-font-bold tw-text-slate-900 dark:tw-text-slate-100 tw-mb-2">Search for members
                </h3>
                <p class="tw-text-sm tw-text-slate-500 dark:tw-text-slate-400 tw-max-w-sm tw-mb-0">
                    Start typing to search for Safety Knights members to connect with.
                </p>
            </div>
            } @else {
            @for (user of users(); track user._id) {
            <div
                class="tw-group tw-relative tw-p-4 tw-bg-white/80 dark:tw-bg-slate-800/60 tw-border tw-border-slate-200/60 dark:tw-border-slate-700/60 tw-rounded-2xl tw-transition-all tw-duration-300 hover:tw-shadow-lg hover:tw-shadow-slate-200/50 dark:hover:tw-shadow-slate-900/50 hover:tw-scale-[1.01] tw-backdrop-blur-sm">

                <div class="tw-flex tw-items-start tw-gap-4">
                    <div class="tw-relative tw-flex-shrink-0">

                        @if (user.profilePictureKey.includes('Avatar')) {
                        <div
                            class="tw-cursor-pointer tw-w-14 tw-h-14 tw-rounded-full tw-object-cover tw-ring-2 tw-ring-white dark:tw-ring-slate-700 tw-shadow-lg tw-transition-all tw-duration-300">
                            <app-user-avatar [pictureKey]="user.profilePictureKey"
                                [pictureTransform]="user.pictureTransform" [pictureID]="user._id">
                            </app-user-avatar>
                        </div>

                        } @else {
                        <img class="tw-cursor-pointer tw-w-14 tw-h-14 tw-rounded-full tw-object-cover tw-ring-2 tw-ring-white dark:tw-ring-slate-700 tw-shadow-lg tw-transition-all tw-duration-300"
                            [src]="[profileApiUrl+user.profilePictureKey]"
                            [style.transform]="'rotate(' + user.pictureTransform + 'deg)'"
                            [alt]="user.firstName + ' ' + user.lastName" loading="lazy">
                        }

                        <!-- Online indicator -->
                        @if (user.isOnline) {
                        <div
                            class="tw-absolute tw--bottom-1 tw--right-1 tw-w-4 tw-h-4 tw-bg-green-500 tw-border-2 tw-border-white dark:tw-border-slate-700 tw-rounded-full">
                        </div>
                        }
                    </div>

                    <div class="tw-flex-1 tw-min-w-0">
                        <div class="tw-flex tw-items-start tw-justify-between tw-mb-2">
                            <div class="tw-flex-1 tw-min-w-0">
                                <h3
                                    class="tw-text-lg tw-font-bold tw-text-slate-900 dark:tw-text-slate-100 tw-leading-tight tw-flex tw-items-center tw-gap-2">
                                    {{ user.firstName }} {{ user.lastName }}
                                    @if (user.admin === 'Yes') {
                                    <span
                                        class="tw-text-xs tw-bg-red-100 tw-text-red-600 tw-px-2 tw-py-1 tw-rounded-full tw-font-medium tw-flex tw-items-center tw-gap-1">
                                        <ng-icon name="heroShieldCheck" size="10"></ng-icon>
                                        ADMIN
                                    </span>
                                    }
                                </h3>
                                <div class="tw-flex tw-items-center tw-gap-2 tw-mt-1">
                                    <ng-icon name="heroBriefcase" size="14" class="tw-text-slate-500"></ng-icon>
                                    <p
                                        class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-400 tw-font-medium tw-mb-0">
                                        {{ user.position }} at {{ user.company }}
                                    </p>
                                </div>
                            </div>

                            <!-- Connection Status Button -->
                            <div class="tw-flex-shrink-0 tw-ml-4">
                                <button (click)="handleConnectionAction(user)"
                                    [disabled]="!canSendRequestToUser(user) && user.connectionStatus !== 'none'"
                                    [class]="getConnectionStatusClasses(user)">
                                    <ng-icon [name]="getConnectionStatusIcon(user)" size="16"></ng-icon>
                                    <span class="tw-hidden sm:tw-inline tw-ml-2">{{ getConnectionStatusText(user)
                                        }}</span>
                                </button>
                            </div>
                        </div>

                        <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-2 tw-mb-3">
                            <div class="tw-flex tw-items-center tw-gap-2">
                                <ng-icon name="heroEnvelope" size="14" class="tw-text-slate-500"></ng-icon>
                                <span class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-400 tw-truncate">{{
                                    user.email }}</span>
                            </div>
                            @if (user.location) {
                            <div class="tw-flex tw-items-center tw-gap-2">
                                <ng-icon name="heroMapPin" size="14" class="tw-text-slate-500"></ng-icon>
                                <span class="tw-text-sm tw-text-slate-600 dark:tw-text-slate-400 tw-truncate">{{
                                    user.location }}</span>
                            </div>
                            }
                            <!-- Stats Row -->
                            <div class="tw-flex tw-items-center tw-gap-4">
                                <div class="tw-flex tw-items-center tw-gap-1">
                                    <span class="tw-text-xs tw-font-bold tw-text-green-600 dark:tw-text-green-400">{{
                                        getFollowerCount(user.followers) }}</span>
                                    <span class="tw-text-xs tw-text-slate-500">Followers</span>
                                </div>
                                <div class="tw-flex tw-items-center tw-gap-1">
                                    <span class="tw-text-xs tw-font-bold tw-text-blue-600 dark:tw-text-blue-400">{{
                                        getFollowingCount(user.following) }}</span>
                                    <span class="tw-text-xs tw-text-slate-500">Following</span>
                                </div>
                            </div>
                        </div>

                        <!-- Bio Preview (if available) -->
                        @if (user.userbio) {
                        <div class="tw-mt-2">
                            <p class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400 tw-line-clamp-2">
                                {{ (user.userbio.substring(0, 120)) + (user.userbio.length > 120 ? '...' : '') }}
                            </p>
                        </div>
                        }

                        <!-- Connection Message Input for Selected User -->
                        @if (selectedUser() && selectedUser()?._id === user._id && canSendRequestToUser(user)) {
                        <div
                            class="tw-mt-4 tw-p-4 tw-bg-indigo-50/50 dark:tw-bg-indigo-950/20 tw-border tw-border-indigo-200/60 dark:tw-border-indigo-800/60 tw-rounded-xl">
                            <label
                                class="tw-block tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-300 tw-mb-2">
                                Personal Message (Optional)
                            </label>
                            <textarea [ngModel]="connectionMessage()" (ngModelChange)="connectionMessage.set($event)"
                                placeholder="Hi {{ user.firstName }}, I'd like to connect with you..." rows="3"
                                maxlength="500"
                                class="tw-w-full tw-px-3 tw-py-2 tw-bg-white dark:tw-bg-slate-900 tw-border tw-border-slate-200 dark:tw-border-slate-700 tw-rounded-lg focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-indigo-500 focus:tw-border-transparent tw-text-sm tw-text-slate-900 dark:tw-text-slate-100 tw-placeholder-slate-500 dark:tw-placeholder-slate-400 tw-resize-none">
                            </textarea>
                            <div class="tw-flex tw-items-center tw-justify-between tw-mt-3">
                                <div class="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400">
                                    {{ connectionMessage().length }}/500
                                </div>
                                <div class="tw-flex tw-items-center tw-gap-2">
                                    <button (click)="selectedUser.set(null); connectionMessage.set('')"
                                        class="tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-slate-600 dark:tw-text-slate-400 hover:tw-text-slate-800 dark:hover:tw-text-slate-200 tw-transition-colors">
                                        Cancel
                                    </button>
                                    <button (click)="sendConnectionRequest()" [disabled]="isLoading()"
                                        class="tw-px-4 tw-py-1.5 tw-bg-gradient-to-r tw-from-indigo-500 tw-to-purple-600 hover:tw-from-indigo-600 hover:tw-to-purple-700 tw-text-white tw-font-medium tw-text-sm tw-rounded-lg tw-shadow-sm tw-transition-all tw-duration-200 hover:tw-scale-105 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed disabled:hover:tw-scale-100 tw-flex tw-items-center tw-gap-2">
                                        @if (isLoading()) {
                                        <div
                                            class="tw-animate-spin tw-rounded-full tw-h-3 tw-w-3 tw-border tw-border-white tw-border-t-transparent">
                                        </div>
                                        <span>Sending...</span>
                                        } @else {
                                        <ng-icon name="heroUserPlus" size="14"></ng-icon>
                                        <span>Send Request</span>
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>

                <!-- Hover Effect -->
                <div
                    class="tw-absolute tw-inset-0 tw-rounded-2xl tw-bg-gradient-to-r tw-from-indigo-500/5 tw-to-purple-500/5 tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300 tw-pointer-events-none">
                </div>
            </div>
            }
            }
        </div>
    </div>
</div>